module.exports = __webpack_public_path__ + "img/price-add-update.7a8a1b0e.svg";